import { render, staticRenderFns } from "./DrugInventoryItemsListing.vue?vue&type=template&id=512d219f&"
import script from "./DrugInventoryItemsListing.vue?vue&type=script&lang=js&"
export * from "./DrugInventoryItemsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports